import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, GET_HOOKAH_MERCHANT_LIST } from '../../../Constants/Config';

const initialState = {
  loading: false,
  hookahList: [],
  error: '',
  total: 0,
  hasMore: true,
};

export const fetchHookahLists = createAsyncThunk(
  'hookahList/fetchHookahLists',
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('page', page); // Use 'page' as the API parameter
      formData.append('limit', limit);

      const response = await axios.post(
        `${BASE_URL_SANDBOX}${GET_HOOKAH_MERCHANT_LIST}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200 && response.data && response.data.data) {
        return {
          hookahList: response.data.data,
          total: response.data.total || 0,
          hasMore: response.data.hasMore ,
        };
      } else {
        return { hookahList: [], total: 0, hasMore: false };
      }
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

const hookahSlice = createSlice({
  name: 'hookahList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchHookahLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHookahLists.fulfilled, (state, action) => {
        state.loading = false;
        state.hookahList = [...state.hookahList, ...(action.payload.hookahList || [])];
        state.total = action.payload.total || 0;
        state.hasMore = action.payload.hasMore || false;
        state.error = '';
      })
      .addCase(fetchHookahLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch hookah merchants';
        state.hasMore = false;
      });
  },
});

export default hookahSlice.reducer;